import { orgAccessDecision, useOrgPermissions } from "@/auth/orgPermissions";
import { useTheme } from "@/theme/ThemeProvider";
import { OrgAccessDenied, SuperadminReadOnlyBanner } from "@/ui/components/OrgAccessDenied";
import { Screen } from "@/ui/components/Screen";
import { ErrorState, LoadingState } from "@/ui/components/StateViews";
import { Stack, useLocalSearchParams } from "expo-router";
import { useEffect } from "react";
import { View } from "react-native";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function param(value: string | string[] | undefined): string {
  if (typeof value === "string") return value;
  return value?.[0] ?? "";
}

export default function TenantLayout() {
  const { theme } = useTheme();
  const tenantID = param(useLocalSearchParams<{ tenantID: string }>().tenantID);
  const valid = UUID_RE.test(tenantID);
  const permissions = useOrgPermissions(valid ? tenantID : undefined);
  const decision = orgAccessDecision({
    validTenantId: valid,
    loading: permissions.loading,
    error: Boolean(permissions.loadError),
    isMember: permissions.isMember,
    isSuperadmin: permissions.isSuperadmin,
  });

  useEffect(() => {
    if (permissions.loadError) console.error("org access", permissions.loadError);
  }, [permissions.loadError]);

  if (decision === "loading") {
    return (
      <Screen>
        <LoadingState message="Wird geladen …" />
      </Screen>
    );
  }

  if (decision === "error") {
    return (
      <Screen>
        <ErrorState
          message="Die Vereinsberechtigung konnte nicht geladen werden."
          onRetry={() => permissions.refetch()}
          retryLabel="Erneut laden"
        />
      </Screen>
    );
  }

  if (decision === "denied") return <OrgAccessDenied />;

  return (
    <View style={{ flex: 1, backgroundColor: theme.color.bg }}>
      {permissions.isReadOnlySuperadmin ? (
        <SuperadminReadOnlyBanner />
      ) : null}
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: theme.color.bg },
        }}
      />
    </View>
  );
}
